export type GoogleMapConfig = {
  googleApiKey: string;
  googleMapsLibraries: string;
};

export const loadGoogleMaps = (config: GoogleMapConfig, callback: Function) => {
  const url = `https://maps.googleapis.com/maps/api/js?key=${config.googleApiKey}&libraries=${config.googleMapsLibraries}&callback=handleMapInit&loading=async`;
  const existingScript = document.head.querySelector(`script[src="${url}"]`);
  if (existingScript) callback();
  else {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.defer = true;
    script.async = true;
    document.head.appendChild(script);
    window.handleMapInit = function () {
      callback();
    };
  }
};
